exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-view .field-group .field-label {\r\n    width: 140px;\r\n}\r\n\r\n.customer-view .field-group .form-control {\r\n    width: calc(100% - 185px);\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/components/customers/View.css
// module id = 372
// module chunks = 0